import { useCallback, useEffect, useState } from "react"

import { getLeadSourceBudgets } from "./lead-source-budgets.services.ts"
import type { LeadSourceBudgetRow } from "./lead-source-budgets.types.ts"

/** Each lead source's budget, keyed by the source's stored value. Loads nothing
 *  when `enabled` is off, so a caller who may not see budgets never asks. */
export function useLeadSourceBudgets(enabled: boolean) {
  const [budgets, setBudgets] = useState<Record<string, LeadSourceBudgetRow>>(
    {}
  )
  const [loading, setLoading] = useState(enabled)
  const [failed, setFailed] = useState(false)

  const reload = useCallback(async () => {
    if (!enabled) return
    const response = await getLeadSourceBudgets()
    if (response.ok) {
      setBudgets(
        Object.fromEntries(
          (response.data?.results ?? []).map((row) => [row.source, row])
        )
      )
      setFailed(false)
    } else {
      setFailed(true)
    }
    setLoading(false)
  }, [enabled])

  useEffect(() => {
    void reload()
  }, [reload])

  return { budgets, loading, failed, reload }
}
